module.exports = __webpack_public_path__ + "img/figure-11.51bb116a.png";